// Fields on the `memberships` object that are populated by the backend for
// display only (active ARB card details) and are NOT columns on the
// membership__c table. They must be stripped from any membership write
// payload, otherwise the INSERT/PATCH references nonexistent columns and the
// backend returns a DATABASE_ERROR (500).
export const MEMBERSHIP_DISPLAY_ONLY_FIELDS = [
  "active_arb_card_type",
  "active_arb_last_4_digits",
  "active_arb_subscription_start_date",
];
